import interpolate from "color-interpolate";

export const CARD_BACKGROUND_COLOR_0 = "#2e3840";
export const CARD_BACKGROUND_COLOR_1 = "#58384f";

export const CARD_BACKGROUND_COLORMAP = interpolate(["#58384f", "#2e3840"]);